<div class="flex flex-wrap items-center gap-1.5">
  @for (chip of chips(); track chip.key) {
    <div class="attr-chip" [class.attr-chip--variant]="chip.def?.type === 'variant'">
      <span class="attr-chip__key">{{ chip.key }}</span>

      @if (editingKey() === chip.key) {
        <!-- Inline edit -->
        @if (chip.def?.type === 'boolean') {
          <!-- DEV-749: commit on ngModelChange, not (change). A chip holding a
               stale string "true" already DISPLAYS true, so re-picking true fires
               no change event and the value stays a string — the only manual
               repair was true -> false -> true. -->
          <select class="attr-chip__inline-input" [ngModel]="editingValue()" (ngModelChange)="editingValue.set($event); confirmEdit()">
            <option value="true">true</option>
            <option value="false">false</option>
          </select>
        } @else if ((chip.def?.options?.length ?? 0) > 0) {
          <select class="attr-chip__inline-input" [ngModel]="editingValue()" (ngModelChange)="editingValue.set($event)" (change)="confirmEdit()">
            @for (opt of chip.def!.options; track opt) {
              <option [value]="opt">{{ opt }}</option>
            }
          </select>
        } @else {
          <input class="attr-chip__inline-input" [ngModel]="editingValue()" (ngModelChange)="editingValue.set($event)" (keydown.enter)="confirmEdit()" (keydown.escape)="cancelEdit()" (blur)="confirmEdit()" />
        }
      } @else {
        <!-- Display value -->
        <span class="attr-chip__value" (click)="startEdit(chip)" [title]="chip.def?.type === 'variant' ? 'Variant (read-only)' : 'Click to edit'">
          {{ chip.value }}
        </span>
      }

      @if (chip.def?.type !== 'variant') {
        <button class="attr-chip__remove" (click)="removeArg(chip.key)" title="Remove">
          <i class="pi pi-times"></i>
        </button>
      }
    </div>
  }

  <!-- Add argument button + popover -->
  <div class="relative inline-block">
    <button class="attr-add-btn" (click)="op.toggle($event)" title="Add argument">
      <i class="pi pi-plus"></i> Add
    </button>
    <p-popover #op appendTo="body">
      <div class="flex flex-col gap-1 min-w-[180px]">
        @if (availableArgs().length > 0) {
          <div class="text-[0.6875rem] text-wb-muted uppercase tracking-wider mb-1">Attach existing</div>
          @for (arg of availableArgs(); track arg.key) {
            <button class="attr-popover-item" (click)="attachArg(arg); op.hide()">
              {{ arg.key }} <span class="text-wb-muted text-[0.7rem] ml-1">{{ arg.type }}</span>
            </button>
          }
          <div class="border-t border-[var(--wb-border)] my-1"></div>
        }
        <button class="attr-popover-item text-wb-accent" (click)="openNewArgDialog(); op.hide()">
          <i class="pi pi-plus mr-1"></i> New argument...
        </button>
      </div>
    </p-popover>
  </div>
</div>

<!-- New arg dialog -->
<p-dialog
  header="New Argument"
  [visible]="newArgDialogVisible()"
  (visibleChange)="newArgDialogVisible.set($event)"
  [modal]="true"
  [style]="{ width: '400px' }"
  appendTo="body"
>
  <div class="flex flex-col gap-3 pt-2">
    <div>
      <label class="text-[0.75rem] text-wb-muted block mb-1">Key</label>
      <input pInputText class="w-full" [ngModel]="newArgKey()" (ngModelChange)="newArgKey.set($event)" placeholder="e.g. gender" />
      @if (newArgKey().trim() && newArgKeyError()) {
        <small class="text-red-400 mt-1 block">{{ newArgKeyError() }}</small>
      } @else {
        <small class="text-wb-muted mt-1 block">Lower case, no spaces — underscores and hyphens are fine.</small>
      }
    </div>
    <div>
      <label class="text-[0.75rem] text-wb-muted block mb-1">Type</label>
      <select class="w-full bg-[var(--wb-bg-surface)] border border-[var(--wb-border)] rounded-lg text-wb-text text-[0.85rem] px-3 py-2 outline-none"
        [ngModel]="newArgType()" (ngModelChange)="onNewArgTypeChange($event)">
        <option value="string">string</option>
        <option value="number">number</option>
        <option value="boolean">boolean</option>
      </select>
    </div>
    @if (newArgType() === 'string') {
      <div>
        <label class="text-[0.75rem] text-wb-muted block mb-1">Options (comma-separated)</label>
        <input pInputText class="w-full" [ngModel]="newArgOptions()" (ngModelChange)="newArgOptions.set($event)" placeholder="e.g. male, female" />
      </div>
    }
    <div>
      <label class="text-[0.75rem] text-wb-muted block mb-1">Default Value</label>
      @if (newArgType() === 'boolean') {
        <p-select class="w-full" [options]="booleanOptions" optionLabel="label" optionValue="value"
                  [ngModel]="newArgDefaultValue()" (ngModelChange)="newArgDefaultValue.set($event)" />
      } @else if (newArgType() === 'number') {
        <p-inputnumber class="w-full" [ngModel]="newArgDefaultValue()" (ngModelChange)="newArgDefaultValue.set($event)" />
      } @else {
        <input pInputText class="w-full" [ngModel]="newArgDefaultValue()" (ngModelChange)="newArgDefaultValue.set($event)" />
      }
    </div>
    <div>
      <label class="text-[0.75rem] text-wb-muted block mb-1">Description</label>
      <input pInputText class="w-full" [ngModel]="newArgDescription()" (ngModelChange)="newArgDescription.set($event)" />
    </div>
  </div>
  <ng-template #footer>
    <div class="flex justify-end gap-2 pt-2">
      <p-button label="Cancel" severity="secondary" (click)="newArgDialogVisible.set(false)" />
      <p-button label="Create & Attach" [disabled]="!!newArgKeyError()" (click)="confirmNewArg()" />
    </div>
  </ng-template>
</p-dialog>
